import React, { Component } from 'react';
import { RouteComponentProps, Link, withRouter } from 'react-router-dom';

import CRMApi from '../../../Api/CRM/CRMApi';
import GetFaqCategoryResponse from '../../../Api/CRM/Responses/FaqCategoryResponse';
import { GetFaqTranslationsResponse } from '../../../Api/CRM/Responses/FaqResponse';
import GetAllLanguagesResponse from '../../../Api/CRM/Responses/LanguagesResponse';
import Faq from '../../../Api/Models/Faq';
import TrueFalseIcon from '../../../components/common/TrueFalseIcon';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

type State = {
    faq: Faq;
    languages: GetAllLanguagesResponse;
    translations: GetFaqTranslationsResponse;
    faqCategories: GetFaqCategoryResponse[];
};

class SingleFaq extends Component<RouteComponentProps<{ id: string }>, State> {
    constructor(props: RouteComponentProps<{ id: string }>) {
        super(props);
        this.state = {
            faq: {} as Faq,
            languages: [],
            translations: [],
            faqCategories: [],
        };
    }

    componentDidMount() {
        this.loadState();
    }

    async loadState() {
        const languages = await CRMApi.languages.getAll();
        const translations = await CRMApi.faqs.getTranslations();
        const faqCategories = await CRMApi.faqCategories.getAllWithoutPagination();

        const { match } = this.props;
        const faq = await CRMApi.faqs.getById(parseInt(match.params.id) || 0);

        this.setState({ languages, translations, faq, faqCategories });
    }

    render() {
        const { faq, languages, translations, faqCategories } = this.state;
        return (
            <Card title="FAQ details">
                <TableDetailsBody>
                    <Row label="Question">{faq.question}</Row>
                    <Row label="Category" showIf={faqCategories.length > 0}>
                        {faqCategories.map((faqCategory) => faqCategory.id === faq.faq_category_id && faqCategory.name)}
                    </Row>
                    <Row label="Language id">{faq.language_id}</Row>
                    <Row label="Language name" showIf={languages.length > 0}>
                        {languages.map((lang) => lang.id === faq.language_id && lang.name)}
                    </Row>
                    <Row label="This is translation of" showIf={translations.length > 0}>
                        {translations.map(
                            (translation) => translation.id === faq.translation_id && translation.question
                        )}
                    </Row>
                    <Row label="Answer">{faq.answer}</Row>
                    <Row label="Order">{faq.order}</Row>
                    <Row label="Is mobile">
                        <TrueFalseIcon status={faq.is_mobile} />
                    </Row>
                    <Row label="Is agent">
                        <TrueFalseIcon status={faq.is_agent} />
                    </Row>
                </TableDetailsBody>
                <Link to={`/faq/${faq.id}/edit`} className="btn btn-default right">
                    Edit FAQ
                </Link>
            </Card>
        );
    }
}

export default withRouter(SingleFaq);
